export const DEFAULT_NAME = '余光管理系统';

export const BRAND_LOGO =
  'https://yu-guang-website.oss-ap-southeast-1.aliyuncs.com/static/logo_128x128.png';

export const SUPPORT_WECHAT_QR =
  'https://yu-guang-website.oss-ap-southeast-1.aliyuncs.com/static/qiuzi_wechat.jpg';

/** 表单双列布局：移动端单列，桌面端双列 */
export const FORM_COL_HALF = { xs: 24, md: 12 } as const;

/** 表单通栏布局 */
export const FORM_COL_FULL = { xs: 24, md: 24 } as const;
